var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPython(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3872A5",
    d: "M180.6,95.7c0-21.9,35.7-26.4,35.7,1.6 c0,12.5-17.6,22.7-29.9,11.2C183.8,106.1,180.6,100.4,180.6,95.7L180.6,95.7z M47.5,258.9v-12c0.7-24.6,5.5-48.9,15.2-64.5 c9.8-15.7,26-29.9,51.3-29.9h142v-13.8H155.4v-13c0-29-7.7-48.7,19.4-65c24-14.3,55.5-15.4,86.9-15.4c35.4,0,94.9,11.1,94.9,53.5 v87.6c0,30.3-10.5,49.1-39.2,57.3c-25.4,7.3-113.5-2-139.4,5.8c-18.3,5.6-29.1,20.4-33.7,38.6c-2,7.8-1.9,12.1-1.9,21.6v36.5 c0.1,11.4,4.5,8.9-30,8.9c-31.4,0-48-19.7-57.1-46.8C50.7,294.9,48,277.2,47.5,258.9L47.5,258.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFD242",
    d: "M295,409.8c0-10.8,8.7-17.8,14.6-17.8c7.2,0,10.5-0.8,16.5,5.4 c2.7,2.8,4.6,6.5,4.6,11.6C330.7,433.6,295,432.4,295,409.8L295,409.8z M369.6,195.5c0,28.2-11.7,50-32,58.1 c-18.7,7.5-61.9,5.2-85.7,5.2c-31,0-56-4.7-78.6,12.3c-22.8,17-18,47-18,72.9l0,66.5c0.6,7,2.9,12,6,16.7 c25.7,38.5,108.3,35.3,144.3,28.1c19.9-4,50.9-16.4,50.9-40v-49.5H255.2v-13.8h146.9c10.1,0,22.5-5.5,28.4-9.7 c23.4-16.6,33.3-50,33.3-81.1c0-26.5,0.3-41.4-8-66.7c-3.5-10.7-9.5-21.2-17-29.3c-17.9-19.5-42.5-15.2-69.2-15.2V195.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.ecb5829c618b019431ae8e13e30f7577.svg";
export { ForwardRef as ReactComponent };